import { format } from "date-fns";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { BookingService } from "@/services/BookingService";

interface UseRoomBookingsForDateOptions {
  locationSlug: string;
  roomId: string;
  date: Date;
  enabled?: boolean;
}

/**
 * Fetches all non-cancelled bookings for a specific room on a specific date.
 * Used by the slot picker to determine which time slots are available.
 */
export function useRoomBookingsForDate({
  locationSlug,
  roomId,
  date,
  enabled = true,
}: UseRoomBookingsForDateOptions) {
  const bookingService = useMemo(() => new BookingService(), []);
  const dateKey = format(date, "yyyy-MM-dd");

  return useQuery({
    queryKey: ["bookings", "room", roomId, dateKey],
    queryFn: async () => {
      const bookings = await bookingService.getBookingsForLocationAndDate(locationSlug, date);
      return bookings.filter((b) => b.roomId === roomId);
    },
    enabled: enabled && !!locationSlug && !!roomId,
    staleTime: 60 * 1000,
  });
}
